module.exports = __webpack_public_path__ + "static/img/weather_033.4cc40ce5.svg";